<!-- The business's own bank accounts - the חשבון מקבל a bank-transfer payment is received into.
     One row per account (bank, branch, account number, remove) and a + to add one. It edits the
     array it is given IN PLACE: Settings hands it the store's array, the ניהול מהיר modal on the
     tax-document page (Accounting/BankAccountsQuickEdit) a local copy that it saves itself.
     validate() paints the row errors and answers whether every row is complete. -->
<template>
    <div class="bankAccountsEditor">

        <div v-for="(bankAccount, index) in accounts"
             :key="index"
             class="row bankAccountRow">

            <div class="col-md-3">
                <div class="mb-3">
                    <label class="form-label">
                        בנק
                    </label>
                    <Multiselect :options="$store.state.banks"
                                 label="name"
                                 track-by="value"
                                 v-model="bankAccount.bank"
                                 selectLabel=""
                                 selectedLabel=""
                                 deselect-label=""
                                 placeholder="">

                        <template slot="noResult">לא נמצאו תוצאות</template>
                        <template slot="noOptions">אין אפשרויות</template>
                    </Multiselect>
                    <span class="formErrorText"
                          v-if="bankAccount.errors">
                        {{ bankAccount.errors.bank }}
                    </span>
                </div>
            </div>

            <div class="col-md-3">
                <div class="mb-3">
                    <label class="form-label">
                        סניף
                    </label>
                    <input class="form-control bankAccountSnifInput"
                           type="number"
                           v-model="bankAccount.snif">
                    <span class="formErrorText"
                          v-if="bankAccount.errors">
                        {{ bankAccount.errors.snif }}
                    </span>
                </div>
            </div>

            <div class="col-md-3">
                <div class="mb-3">
                    <label class="form-label">
                        חשבון
                    </label>
                    <input class="form-control bankAccountNumberInput"
                           type="number"
                           v-model="bankAccount.account">
                    <span class="formErrorText"
                          v-if="bankAccount.errors">
                        {{ bankAccount.errors.account }}
                    </span>
                </div>
            </div>

            <div class="col-md-3">
                <div class="mb-3">
                    <label class="form-label"
                           style="visibility:hidden">
                        .
                    </label>
                    <div>
                        <i class="fa-regular fa-trash-can trashButton removeBankAccountButton"
                           style="cursor:pointer;color:#999"
                           @click="removeAccount(index)"></i>
                    </div>
                </div>
            </div>

        </div>

        <div v-if="!accounts.length"
             class="bankAccountsEditorEmpty">
            עדיין לא הוגדרו חשבונות בנק.
        </div>

        <div>
            <span @click="addAccount()"
                  class="addBankAccountButton"
                  style="color:#8d63da;cursor:pointer;font-size:25px;">
                <i class="fa-solid fa-plus"></i>
            </span>
        </div>

    </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

export default {
    name: 'BankAccountsEditor',

    props: ['accounts'],

    methods: {

        // explicit keys so the row is reactive from the first keystroke (a bare {} would take its
        // properties non-reactively when v-model first assigns them)
        addAccount() {
            this.accounts.push({ bank: null, snif: null, account: null });
        },

        removeAccount(index) {
            this.accounts.splice(index, 1);
        },

        // paints an error under every empty field and tells whether all rows are complete
        validate() {

            let valid = true;

            this.accounts.forEach(bankAccount => {

                let errors = {};

                if (!bankAccount.bank)
                    errors.bank = 'נא לבחור בנק';

                if (!bankAccount.snif)
                    errors.snif = 'נא להזין סניף';

                if (!bankAccount.account)
                    errors.account = 'נא להזין חשבון';

                this.$set(bankAccount, 'errors', errors);

                if (Object.values(errors).some(value => value))
                    valid = false;
            });

            return valid;
        },
    },

    components: { Multiselect }
}
</script>

<style>
.bankAccountsEditorEmpty {
    color: #888;
    margin-bottom: 10px;
}
</style>
